/**
 * Do not edit directly, this file was auto-generated.
 */

export const PRIMARY_BLUE_100 = '#e7f8fc'

export const PRIMARY_BLUE_200 = '#d1edf7'

export const PRIMARY_BLUE_500 = '#18a5d6'

export const PRIMARY_BLUE_700 = '#007199'

export const PRIMARY_BLUE_900 = '#004e69'

export const PRIMARY_RED_200 = '#fddce3'

export const PRIMARY_RED_500 = '#f01446'

export const PRIMARY_RED_700 = '#bd0c33'

export const PRIMARY_RED_900 = '#8b0020'

export const PRIMARY_GREY_500 = '#bdbdbd'

export const PRIMARY_GREY_700 = '#363636'

export const PRIMARY_GREY_900 = '#232221'

export const PRIMARY_GREY_000 = '#ffffff'

export const PRIMARY_SAND_100 = '#f6f1eb'

export const PRIMARY_SAND_200 = '#e3ddd3'

export const PRIMARY_SAND_500 = '#b8afa4'

export const PRIMARY_SAND_700 = '#807a74'

export const PRIMARY_SAND_900 = '#59544e'

export const SECONDARY_GREEN_200 = '#e7f9ec'

export const SECONDARY_GREEN_500 = '#66dc88'

export const SECONDARY_GREEN_800 = '#02715c'

export const SECONDARY_RED_200 = '#ffeceb'

export const SECONDARY_RED_500 = '#ff4336'

export const SECONDARY_YELLOW_200 = '#ffeac9'

export const SECONDARY_YELLOW_500 = '#e9ae5a'

export const SECONDARY_YELLOW_800 = '#8a400b'

export const SECONDARY_GREY_400 = '#f5f6f9'

export const SECONDARY_MINT_300 = '#d9f8f6'

export const SECONDARY_MINT_700 = '#2e8d87'

export const TERTIARY_SPOTIFY = '#00d95a'

export const TERTIARY_WHATSAPP = '#25d366'

export const TERTIARY_VIMEO = '#1ab7ea'

export const TERTIARY_X = '#000000'

export const TERTIARY_FACEBOOK = '#0574f6'

export const TERTIARY_LINKEDIN = '#2867b2'

export const TERTIARY_TWITCH = '#9246ff'

export const TERTIARY_INSTAGRAM = '#f30074'

export const TERTIARY_YOUTUBE = '#ff0000'

export const TERTIARY_GOOGLE = '#db4437'

export const TERTIARY_SOUNDCLOUD = '#ff5500'

export const TERTIARY_BANDCAMP = '#61929c'

export const TERTIARY_MESSENGER = '#057ff5'

export const TERTIARY_BLUESKY = '#295ef6'

export const TERTIARY_TIKTOK = '#000000'

export const TERTIARY_MASTODON = '#6364ff'

export const TERTIARY_DISCORD = '#5865f2'

export const TERTIARY_LINKTREE = '#43e660'

export const BRAND_GREEN = '#02715c'

export const BRAND_PURPLE = '#9e3f78'

export const BRAND_YELLOW = '#fdce03'

export const BRAND_INDIGO = '#3e51b5'

export const BRAND_ORANGE = '#f86802'

export const BACKGROUND_PRIMARY = '#ffffff'

export const BACKGROUND_SECONDARY = '#f6f1eb'

export const BACKGROUND_TERTIARY = '#e7f8fc'

export const BACKGROUND_SUCCESS = '#e7f9ec'

export const BACKGROUND_ERROR = '#ffeceb'

export const BACKGROUND_ALERT = '#fef4e7'

export const BACKGROUND_DISABLED = '#f5f6f9'

export const BACKGROUND_OVERLAY = '#23222166'

export const BACKGROUND_BUTTON_PRIMARY = '#18a5d6'

export const BACKGROUND_BUTTON_PRIMARY_HOVER = '#007199'

export const BACKGROUND_BUTTON_SECONDARY = '#f01446'

export const BACKGROUND_BUTTON_SECONDARY_HOVER = '#bd0c33'

export const BACKGROUND_BUTTON_TERTIARY = '#66dc88'

export const BACKGROUND_BUTTON_TERTIARY_HOVER = '#02715c'

export const BACKGROUND_BUTTON_DISABLED = '#bdbdbd'

export const BORDER_PRIMARY = '#e3ddd3'

export const BORDER_HOVER = '#18a5d6'

export const BORDER_SUCCESS = '#66dc88'

export const BORDER_ERROR = '#ff4336'

export const BORDER_DISABLED = '#bdbdbd'

export const TEXT_PRIMARY = '#232221'

export const TEXT_SECONDARY = '#59544e'

export const TEXT_TERTIARY = '#807974'

export const TEXT_LINK = '#18a5d6'

export const TEXT_LINK_HOVER = '#007199'

export const TEXT_HEADING_BLUE = '#004e69'

export const TEXT_RED = '#f01446'

export const TEXT_RED_HOVER = '#bd0c33'

export const TEXT_HEADING_RED = '#8b0020'

export const TEXT_SUCCESS = '#02715c'

export const TEXT_ERROR = '#ff4336'